import {styled} from "@mui/system";
import {Box, Typography} from "@mui/material";

export const Wrapper = styled(Box)({
    display: "flex",
    padding: "24px 32px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    flex: "1 0 0",
    alignSelf: "stretch",
})

export const Title = styled(Typography)({
    color: "var(--brand-default-color)",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: "0.15px",
})

export const Headline = styled(Typography)({
    alignSelf: "stretch",
    color: "var(--grey-grey-06)",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0.1px",
})

export const Element = styled(Box)({
    gap: "16px",
    alignSelf: "stretch",
    width: "400px"
})
